import React, { useEffect } from "react";
import {
  AdyenPlatformExperience,
  TransactionsOverview,
  fr_FR
} from "@adyen/adyen-platform-experience-web";
import "@adyen/adyen-platform-experience-web/adyen-platform-experience-web.css";
interface SessionObject {
  id: string;
  token: string;
}

export function AdyenTransactionsOverview() {
 
  async function sessionRequest(): Promise<SessionObject> {
    const urlGetTokenReportSession: string = `${process.env.REACT_APP_ADMIN_ACCESS}/getTokenReportSession`;
    let sessionObject: SessionObject = { id: "", token: "" };
    const accountHolderId = localStorage.getItem("accountHolderId");
    const role = localStorage.getItem("role");
    await fetch(urlGetTokenReportSession, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: `accountHolderId=${accountHolderId}&role=${role}`,
      method: "POST",
    })
      .then((result) => result.json())
      .then(async (response: any) => {
        sessionObject = response;
        if (response.error) {
        }
      })
      .catch((err: any) => {
        return false;
      });

    return sessionObject;
  }

  useEffect(() => {
    const initializeAdyenExperience = async () => {
      const core = await AdyenPlatformExperience({
        locale: "fr-FR", 
        availableTranslations: [fr_FR],
        async onSessionCreate() {
          const session = await sessionRequest();
          return session;
        },
      });

      const transactionsOverview = new TransactionsOverview({ core });
      transactionsOverview.mount("#transactions-overview-container");
    };

    initializeAdyenExperience();

    // Cleanup function to unmount the component
    return () => {
      // If needed, you can add unmount logic here
      // e.g., transactionsOverview.unmount();
    };
  }, []);

  return (
    <React.Fragment>
      <div
        style={{ width: "100%", marginTop: "30px", marginLeft: "7px" }}
        id="transactions-overview-container"
      ></div>
    </React.Fragment>
  );
}
